/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */

import type { AmountPrecision } from './AmountPrecision';
import type { AnyValue } from './AnyValue';
import type { ConfigurationFieldRules } from './ConfigurationFieldRules';
import type { ConfigurationFieldType } from './ConfigurationFieldType';
import type { CurrencyCode } from './CurrencyCode';
import type { PaymentConfigBehavior } from './PaymentConfigBehavior';
import type { TaxTypes } from './TaxTypes';

/**
 * Configuration field with all possible attributes. Field type determines which attributes are relevant.
 */
export type ConfigurationField = {
    /**
     * Unique identifier of a field.
     */
    name: string;
    type: ConfigurationFieldType;
    /**
     * Specifies whether configuration needs to be reloaded after field is changed.
     */
    requiresConfigReload: boolean;
    /**
     * Specifies whether the field can be changed after its value is saved.
     */
    editable: boolean;
    /**
     * A value in a form which depends on the `type` attribute — see the type-to-value mapping table in the [`AnyValue`](#model-AnyValue).
     */
    value?: AnyValue;
    /**
     * Initial value until it was changed with payment config input. Must be same type as value.
     */
    initialValue?: AnyValue;
    /**
     * Available values for selection fields.
     */
    values?: Array<{
        /**
         * The selectable value.
         */
        value: AnyValue;
        /**
         * Unique identifier of a field which this field is linked to.
         */
        linkedField?: string;
        /**
         * List of behaviors for this value.
         */
        behaviors?: Array<string>;
        /**
         * Display name for the value.
         */
        displayName?: string;
    }>;
    /**
     * List of behaviors provide field with extended features that are not covered by the configuration.
     */
    behaviors: Array<PaymentConfigBehavior>;
    /**
     * Set of rules to verify that value is in compliance with valid business principles.
     * The validation is in place if field's value doesn't fulfill rule's condition.
     * Further processing of the field is not possible until condition is fulfilled.
     *
     */
    validations: Array<ConfigurationFieldRules>;
    /**
     * Set of rules to provide additional information relevant to business principles.
     * The message is in place if field's value fulfills rule's condition.
     * It has not impact on further processing of the field.
     *
     */
    messages: Array<ConfigurationFieldRules>;
    /**
     * Contains characters that are valid to be used in value or initial value attributes.
     */
    allowedInputCharacters?: string;
    /**
     * Precision for amount fields. Only applicable for type `AMOUNT`.
     */
    precision?: AmountPrecision;
    /**
     * Currency code for amount fields. Only applicable for type `AMOUNT`.
     */
    currency?: CurrencyCode;
    /**
     * List of available currencies for amount fields. Only applicable for type `AMOUNT`.
     */
    availableCurrencies?: Array<CurrencyCode>;
    /**
     * Tax types for tax position fields.
     */
    taxTypes?: TaxTypes;
    /**
     * List of suggested values for the field.
     */
    suggestedValues?: Array<{
        /**
         * The suggested value.
         */
        value: AnyValue;
    }>;
    /**
     * Bill payment specific data.
     */
    billPaymentData?: {
        /**
         * Value that should be displayed as the label of the bill payment field.
         */
        displayName?: string;
        /**
         * Suggested restriction of the input value.
         */
        inputFormat?: ConfigurationField.inputFormat;
        /**
         * Flag marking whether this field is a part of a barcode bill payment (true) or a regular bill payment (false).
         */
        barcode: boolean;
    };
};

export namespace ConfigurationField {

    /**
     * Suggested restriction of the input value.
     */
    export enum inputFormat {
        UPPERCASE_TEXT = 'UPPERCASE_TEXT',
        TEXT = 'TEXT',
        NUMERIC = 'NUMERIC',
    }


}

